/* ==========================================================================
   EDME — Main Collection (filtre + sıralama + ürün kartı davranışları)
   --------------------------------------------------------------------------
   Bu dosya koleksiyon section'ını ([data-edme-collection]) çalıştırır:
     1) Filtre aç/kapa (sidebar + overlay) ve Shopify YEREL facet filtreleme
        (checkbox / fiyat aralığı → URL'e yazıp yönlendirir).
     2) Sıralama menüsü (data-sort-value → sort_by URL parametresi).
     3) Ürün kartı: renk (swatch) + beden tıklaması.
     4) Ürün kartı görsel carousel'i:
          - Masaüstü: görselin üzerinde mouse'u sağa-sola gezdir → görsel değişir
            değişir (hover-scrub). Mouse çıkınca ilk görsele döner.
          - Mobil: parmakla sağa-sola swipe.
          - Dot'lara tıklama + (varsa) ok tuşları.
        Görünürlük tamamen `.edme-pcard__slide.is-active` sınıfıyla yönetilir;
        böylece CSS ister opacity ister display kullansın çalışır.

   Çakışma güvenliği:
     - Renk/beden, global `edme-product-card.js` ile aynı bayrağı (edmeSwBound)
       paylaşır → hangi dosya önce yakalarsa o bağlar, diğeri atlar (çift tetik yok).
     - Carousel için ayrı bayrak (__edmeColCarousel) kullanılır.

   Kurulum: assets'e koy; section liquid zaten
     <script src="{{ 'edme-main-collection.js' | asset_url }}" defer></script>
   ile yüklüyor.
   ========================================================================== */

(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     YARDIMCI: aktif facet + sıralamadan URL kurup yönlendir
     ---------------------------------------------------------------------- */
  function buildUrlFromForm(form, opts) {
    opts = opts || {};
    var params = new URLSearchParams();

    if (form) {
      // checkbox (list / boolean facet)
      form.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        if (cb.checked && cb.name) params.append(cb.name, cb.value);
      });
      // fiyat aralığı (number input)
      form.querySelectorAll('input[type="number"]').forEach(function (inp) {
        var v = (inp.value || '').trim();
        if (v !== '' && inp.name) params.append(inp.name, v);
      });
    }

    // Mevcut sıralamayı koru (yoksa opts ile gelen)
    var current = new URLSearchParams(window.location.search);
    var sortBy = opts.sortBy || current.get('sort_by');
    if (sortBy) params.set('sort_by', sortBy);

    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function navigate(url) {
    window.location.assign(url);
  }

  /* ----------------------------------------------------------------------
     FİLTRE: aç/kapa + facet uygula
     ---------------------------------------------------------------------- */
  function initFilters(root) {
    var toggle = root.querySelector('[data-filter-toggle]');
    var sidebar = root.querySelector('[data-filter-sidebar]');
    var closeBtn = root.querySelector('[data-filter-close]');
    var overlay = root.querySelector('[data-filter-overlay]');
    var form = root.querySelector('[data-filter-form]');

    // CSS sözleşmesi:
    //  - sidebar açık: .edme-col__body üzerinde "is-filter-open"
    //  - overlay görünür: .edme-col__overlay üzerinde "is-visible"
    //  - sidebar visibility:visible olabilmesi için .edme-col üzerinde "is-ready"
    //  - filtre açıkken grid sütunları: .edme-col__grid üzerinde "is-cols-filtered"
    var body = root.querySelector('[data-col-body]') || root.querySelector('.edme-col__body');
    var colRoot = (root.matches && root.matches('.edme-col')) ? root : (root.querySelector('.edme-col') || root);
    var grid = root.querySelector('[data-product-grid]') || root.querySelector('.edme-col__grid');

    // Sidebar'ın görünür olabilmesi için kökü "hazır" işaretle (CSS: .edme-col.is-ready)
    if (colRoot && colRoot.classList) colRoot.classList.add('is-ready');

    function isMobile() {
      return window.matchMedia ? window.matchMedia('(max-width: 990px)').matches : window.innerWidth <= 990;
    }
    function isOpen() {
      return body ? body.classList.contains('is-filter-open') : false;
    }
    function openSidebar() {
      if (!sidebar || !body) return;
      body.classList.add('is-filter-open');
      sidebar.setAttribute('aria-hidden', 'false');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (grid && grid.classList) grid.classList.add('is-cols-filtered');
      // Overlay yalnızca MOBİLDE (≤990px) gösterilir; masaüstünde sidebar
      // içeriği yana iter, karartıya gerek yok (eski davranış).
      if (overlay && isMobile()) { overlay.hidden = false; overlay.classList.add('is-visible'); }
    }
    function closeSidebar() {
      if (!sidebar || !body) return;
      body.classList.remove('is-filter-open');
      sidebar.setAttribute('aria-hidden', 'true');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (grid && grid.classList) grid.classList.remove('is-cols-filtered');
      if (overlay) {
        overlay.classList.remove('is-visible');
        // overlay geçişi bitince gizle (anında hidden, transition'ı bozmasın diye küçük gecikme)
        setTimeout(function () { if (!isOpen() && overlay) overlay.hidden = true; }, 320);
      }
    }
    function toggleSidebar() {
      if (isOpen()) closeSidebar();
      else openSidebar();
    }

    if (toggle && !toggle.disabled) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        toggleSidebar();
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); closeSidebar(); });
    if (overlay) overlay.addEventListener('click', closeSidebar);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) closeSidebar();
    });

    if (form) {
      // checkbox değişince anında uygula
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.type === 'checkbox') {
          navigate(buildUrlFromForm(form));
        }
      });

      // fiyat alanı: Enter veya alandan çıkınca (blur/change) uygula
      form.querySelectorAll('input[type="number"]').forEach(function (inp) {
        inp.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            navigate(buildUrlFromForm(form));
          }
        });
        inp.addEventListener('change', function () {
          navigate(buildUrlFromForm(form));
        });
      });

      // Form submit (Enter vb.) → yönlendir
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        navigate(buildUrlFromForm(form));
      });
    }

    // "Filtreleri Temizle" zaten <a href="{{ collection.url }}"> ; native çalışır.
    // Yine de garanti olsun diye bağlıyoruz (sıralamayı da sıfırlar → sade temizlik).
    var clear = root.querySelector('[data-filter-clear]');
    if (clear) {
      clear.addEventListener('click', function (e) {
        // href varsa onu kullan; yoksa pathname'e dön
        var href = clear.getAttribute('href');
        if (href) return; // native anchor; bırak gitsin
        e.preventDefault();
        navigate(window.location.pathname);
      });
    }
  }

  /* ----------------------------------------------------------------------
     SIRALAMA: menü aç/kapa + seçim
     ---------------------------------------------------------------------- */
  function initSort(root) {
    var wrapper = root.querySelector('[data-sort-wrapper]');
    if (!wrapper) return;
    var btn = wrapper.querySelector('[data-sort-btn]');
    var menu = wrapper.querySelector('[data-sort-menu]');
    if (!btn || !menu) return;

    function openMenu() {
      menu.hidden = false;
      wrapper.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
    function closeMenu() {
      menu.hidden = true;
      wrapper.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
    function toggleMenu() {
      if (menu.hidden) openMenu();
      else closeMenu();
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleMenu();
    });

    menu.querySelectorAll('[data-sort-value]').forEach(function (li) {
      li.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var val = li.getAttribute('data-sort-value');
        if (!val) return;
        var form = root.querySelector('[data-filter-form]');
        navigate(buildUrlFromForm(form, { sortBy: val }));
      });
    });

    // Dışarı tıklayınca kapat
    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ----------------------------------------------------------------------
     ÜRÜN KARTI: renk (swatch) + beden
     (global edme-product-card.js ile aynı bayrağı paylaşır → çift bağlamaz)
     ---------------------------------------------------------------------- */
  function bindSwatchSize(card) {
    if (card.dataset.edmeSwBound === '1') return;
    card.dataset.edmeSwBound = '1';

    var primaryImg = card.querySelector('[data-pcard-primary]');
    var colorNameEl = card.querySelector('[data-pcard-color-label]');
    var sizesContainer = card.querySelector('[data-pcard-sizes]');
    var fallbackUrl = card.getAttribute('data-product-url');

    var swatches = card.querySelectorAll('.edme-pcard__swatch');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');

        var newImg = sw.getAttribute('data-swatch-image');
        var colorName = sw.getAttribute('data-color-value') || '';

        if (newImg) {
          var targetImg = primaryImg;
          if (!targetImg) {
            targetImg = card.querySelector('.edme-pcard__slide.is-active img')
              || card.querySelector('.edme-pcard__slide img')
              || card.querySelector('.edme-pcard__img');
          }
          if (targetImg) {
            targetImg.removeAttribute('srcset');
            targetImg.src = newImg;
          }
        }

        if (colorNameEl && colorName) {
          colorNameEl.textContent = colorName.toLowerCase();
        }
      });
    });

    if (sizesContainer) {
      sizesContainer.querySelectorAll('.edme-pcard__size').forEach(function (sz) {
        sz.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (sz.disabled) return;
          var variantId = sz.getAttribute('data-variant-id');
          if (variantId && fallbackUrl) {
            var sep = fallbackUrl.indexOf('?') > -1 ? '&' : '?';
            window.location.href = fallbackUrl + sep + 'variant=' + variantId;
          }
        });
      });
    }
  }

  /* ----------------------------------------------------------------------
     ÜRÜN KARTI GÖRSEL CAROUSEL'İ
     - Masaüstü: hover-scrub (mouse'u sağa-sola gezdir → görsel değişir)
     - Mobil: touch swipe
     - Dot tıklama + ok tuşları
     - Görünürlük .is-active sınıfıyla; track transform'una dokunmaz.
     ---------------------------------------------------------------------- */
  function initCarousel(card) {
    if (card.__edmeColCarousel) return;
    card.__edmeColCarousel = true;

    var media = card.querySelector('.edme-pcard__media');
    var track = card.querySelector('[data-pcard-track]');
    if (!media || !track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.edme-pcard__slide'));
    var slideCount = slides.length;
    if (slideCount <= 1) return; // tek görsel → carousel gereksiz

    var prevBtn = card.querySelector('[data-pcard-prev]');
    var nextBtn = card.querySelector('[data-pcard-next]');
    var link = card.querySelector('[data-pcard-link]');

    var index = 0;

    // Orijinal galeri (ürünün kendi rengi) — geri yükleme için sakla
    var originalTrackHTML = track.innerHTML;
    var originalLinkHref = link ? link.getAttribute('href') : null;

    function buildSlidesHTML(urls) {
      return urls.map(function (u, i) {
        return '<div class="edme-pcard__slide' + (i === 0 ? ' is-active' : '') + '" data-slide-index="' + i + '">' +
          '<img class="edme-pcard__img' + (i === 0 ? ' edme-pcard__img--primary' : '') + '"' +
          (i === 0 ? ' data-pcard-primary' : '') +
          ' src="' + u + '" alt="" ' + (i === 0 ? 'loading="eager"' : 'loading="lazy"') + '>' +
        '</div>';
      }).join('');
    }
    function requery() {
      slides = Array.prototype.slice.call(track.querySelectorAll('.edme-pcard__slide'));
      slideCount = slides.length;
    }

    function preventGhostDrag() {
      track.querySelectorAll('img').forEach(function (img) {
        if (img.__edmeNoDrag) return;
        img.__edmeNoDrag = true;
        img.addEventListener('dragstart', function (e) { e.preventDefault(); });
      });
    }

    function show(i) {
      if (slideCount < 1) return;
      index = (i + slideCount) % slideCount;
      slides.forEach(function (s, k) {
        var on = (k === index);
        s.classList.toggle('is-active', on);
        // Görünürlüğü doğrudan JS yönetir (koleksiyon CSS'i .is-active'e
        // slide görünürlüğü bağlamıyor): aktif görünür, diğerleri gizli.
        s.style.display = on ? '' : 'none';
      });
    }

    // Carousel'i verilen görsel listesiyle yeniden kurar (renk seçimi için)
    function applySet(urls, productUrl) {
      var list = (urls && urls.length) ? urls : [];
      if (!list.length) return;
      track.innerHTML = buildSlidesHTML(list);
      if (link && productUrl) link.setAttribute('href', productUrl);
      requery();
      preventGhostDrag();
      index = 0;
      show(0);
    }

    // Ürünün kendi (varsayılan) galerisine geri döner
    function restore() {
      track.innerHTML = originalTrackHTML;
      if (link && originalLinkHref != null) link.setAttribute('href', originalLinkHref);
      requery();
      preventGhostDrag();
      index = 0;
      show(0);
    }

    // İlk durum
    requery();
    preventGhostDrag();
    show(0);

    // --- Ok tuşları (CSS ile gizli olsalar da zarar vermez) ---
    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); show(index - 1);
    });
    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); show(index + 1);
    });

    // --- RENK KUTUCUKLARI ↔ CAROUSEL ---
    // Bir renk seçilince carousel'i o rengin görselleriyle yeniden kurar:
    //   - data-swatch-images (çoklu, '|' ayrılmış) varsa → çoklu fotoğraf + kaydırma
    //   - sadece data-swatch-image (tek) varsa → tek fotoğraf
    //   - ürünün kendi (varsayılan) rengine dönülünce → orijinal galeri
    // Global swatch bağlayıcısından bağımsız çalışır; görsel mantığı tek yerde.
    var swatches = Array.prototype.slice.call(card.querySelectorAll('.edme-pcard__swatch'));
    if (swatches.length) {
      var defaultSwatch = card.querySelector('.edme-pcard__swatch.is-active') || swatches[0];
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          if (sw === defaultSwatch) { restore(); return; }
          var productUrl = sw.getAttribute('data-product-url');
          var multi = sw.getAttribute('data-swatch-images');
          var single = sw.getAttribute('data-swatch-image');
          var urls = [];
          if (multi) {
            urls = multi.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
          }
          if (!urls.length && single) urls = [single];
          if (urls.length) applySet(urls, productUrl);
        });
      });
    }

    // --- MASAÜSTÜ: hover-scrub ---
    // İnce işaretçili (mouse) cihazlarda: görselin üzerinde yatay konuma göre
    // slide seç. Mouse çıkınca ilk görsele dön.
    var finePointer = !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (finePointer) {
      media.addEventListener('mousemove', function (e) {
        var rect = media.getBoundingClientRect();
        if (rect.width <= 0) return;
        var x = e.clientX - rect.left;
        if (x < 0) x = 0;
        if (x > rect.width) x = rect.width;
        var zone = Math.floor((x / rect.width) * slideCount);
        if (zone >= slideCount) zone = slideCount - 1;
        if (zone !== index) show(zone);
      });
      media.addEventListener('mouseleave', function () {
        show(0);
      });
    }

    // --- MOBİL: touch swipe ---
    var touchStartX = 0;
    var touchStartY = 0;
    var touchEndX = 0;
    var isSwiping = false;

    media.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
      touchEndX = touchStartX;
      isSwiping = false;
    }, { passive: true });

    media.addEventListener('touchmove', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var dx = Math.abs(touchEndX - touchStartX);
      var dy = Math.abs(e.changedTouches[0].screenY - touchStartY);
      if (dx > dy && dx > 10) isSwiping = true;
    }, { passive: true });

    media.addEventListener('touchend', function () {
      if (!isSwiping) return;
      var diff = touchStartX - touchEndX;
      var threshold = 40;
      if (diff > threshold) show(index + 1);
      else if (diff < -threshold) show(index - 1);
      isSwiping = false;
    }, { passive: true });

    // Sürükleme/swipe sırasında linke gitmeyi engelle
    if (link) {
      link.addEventListener('click', function (e) {
        if (isSwiping) {
          e.preventDefault();
          e.stopPropagation();
          isSwiping = false;
        }
      });
    }

    // Görselin tarayıcı "ghost drag"ini engelle
    media.querySelectorAll('img').forEach(function (img) {
      img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  function initProductCard(card) {
    if (!card) return;
    bindSwatchSize(card);
    if (card.hasAttribute('data-pcard-carousel')) {
      initCarousel(card);
    }
  }

  /* ----------------------------------------------------------------------
     SECTION KURULUMU
     ---------------------------------------------------------------------- */
  function initCollection(root) {
    if (!root || root.__edmeCollectionInit) return;
    root.__edmeCollectionInit = true;

    initFilters(root);
    initSort(root);

    root.querySelectorAll('.edme-pcard').forEach(initProductCard);
  }

  function initAll(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    ctx.querySelectorAll('[data-edme-collection]').forEach(initCollection);
    // Section dışında kalan kartlar (ör. dinamik) için de kart davranışlarını uygula
    ctx.querySelectorAll('.edme-pcard').forEach(initProductCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Tema editöründe section yeniden yüklenince
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (!t || !t.querySelectorAll) return;
    // section'ın kendisi [data-edme-collection] olabilir veya içinde barındırabilir
    if (t.matches && t.matches('[data-edme-collection]')) {
      t.__edmeCollectionInit = false;
      initCollection(t);
    } else {
      t.querySelectorAll('[data-edme-collection]').forEach(function (el) {
        el.__edmeCollectionInit = false;
        initCollection(el);
      });
    }
    t.querySelectorAll('.edme-pcard').forEach(initProductCard);
  });

  // Dinamik kartlar (son gezilenler / sepete son eklenenler) sonradan basıldığında
  document.addEventListener('edme:product-cards-rendered', function (e) {
    var container = (e.detail && e.detail.container) || document;
    container.querySelectorAll('.edme-pcard').forEach(initProductCard);
  });

  // Dışarıdan elle çağırmak isteyen olursa
  window.edmeInitCollection = initAll;
})();